/**
 * Burst — a ripple ring that expands from the center of its parent when
 * `trigger` turns true (not on first render). Used for "Added to slip".
 * Parent should clip (`overflow: 'hidden'`). Reduced motion: no-op.
 */
import React, { useEffect, useRef } from 'react';
import { Animated, View, StyleSheet } from 'react-native';
import { timing, prefersReducedMotion } from '../../utils/motion';

export default function Burst({ trigger, color = 'rgba(16,185,129,0.55)', size = 44 }) {
    const t = useRef(new Animated.Value(0)).current;
    const was = useRef(!!trigger);

    useEffect(() => {
        const now = !!trigger;
        const fire = now && !was.current;
        was.current = now;
        t.setValue(0);   // a ring interrupted by a quick un-add never stays frozen mid-flight
        if (!fire || prefersReducedMotion()) return undefined;
        const anim = timing(t, 1, { duration: 560, easing: 'out' });
        anim.start();
        return () => anim.stop();
    }, [trigger, t]);

    return (
        <View style={[StyleSheet.absoluteFill, { alignItems: 'center', justifyContent: 'center', pointerEvents: 'none' }]}>
            <Animated.View
                style={{
                    width: size,
                    height: size,
                    borderRadius: size / 2,
                    borderWidth: 2,
                    borderColor: color,
                    opacity: t.interpolate({ inputRange: [0, 0.15, 1], outputRange: [0, 0.9, 0] }),
                    transform: [{ scale: t.interpolate({ inputRange: [0, 1], outputRange: [0.3, 3.4] }) }],
                }}
            />
        </View>
    );
}
